export function assertNever(hopefullyNotPossibleValue: never): never {
    throw new Error(`Did not expect this value: ${hopefullyNotPossibleValue}`);
}
